// Mock data for Dr. Kotecha's Dental Clinic

export const clinicInfo = {
  name: "Dr. Kotecha's Dental Clinic",
  tagline: "Excellence in Dental Care Since 1995",
  experience: "30+",
  address: "Shop no. 11 First floor, Rodium X one, 67, Shankar Ln, Kandivali, Kandivali West, Mumbai, Maharashtra 400067",
  phone: "7666222997",
  email: "drkkotecha@yahoo.com",
  workingHours: {
    weekdays: "Mon - Sat: 10:00 AM - 1:00 PM & 4:00 PM - 8:00 PM",
    weekend: "Sunday: Closed"
  }
};

export const doctors = [
{
  id: 1,
  name: "Dr. Kalpesh Kotecha",
  qualification: "BDS, MDS",
  specialization: "Prosthodontist & Implantologist",
  experience: "30+ years",
  description: "Dr. Kalpesh Kotecha brings over three decades of expertise in advanced dental care, specializing in prosthetic dentistry and dental implants. His commitment to excellence and patient comfort has made him a trusted name in Kandivali.",
  image: "https://images.unsplash.com/photo-1622253692010-333f2da6031d?q=80&w=800"
},
{
  id: 2,
  name: "Dr. Shwetal Kotecha",
  qualification: "BDS, MDS",
  specialization: "Cosmetic & Restorative Dentistry",
  experience: "25+ years",
  description: "Dr. Shwetal Kotecha is dedicated to creating beautiful, healthy smiles through advanced cosmetic and restorative procedures. Her gentle approach and attention to detail ensure exceptional patient care.",
  image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?q=80&w=800"
}];


export const services = [
{
  id: 1,
  title: "General Dentistry",
  description: "Comprehensive oral health care including routine checkups, cleanings, fillings, and preventive treatments.",
  icon: "Stethoscope"
},
{
  id: 2,
  title: "Cosmetic Dentistry",
  description: "Transform your smile with teeth whitening, veneers, bonding, and smile makeovers using advanced techniques.",
  icon: "Sparkles"
},
{
  id: 3,
  title: "Dental Implants",
  description: "Permanent tooth replacement solutions using state-of-the-art implant technology for natural-looking results.",
  icon: "Drill"
},
{
  id: 4,
  title: "Root Canal Treatment",
  description: "Pain-free endodontic procedures to save infected teeth using modern rotary endodontics and digital imaging.",
  icon: "Activity"
},
{
  id: 5,
  title: "Orthodontics",
  description: "Straighten teeth and correct bite issues with braces, aligners, and other orthodontic treatments.",
  icon: "Smile"
},
{
  id: 6,
  title: "Oral Surgery",
  description: "Expert surgical procedures including wisdom tooth extraction, jaw surgery, and other oral interventions.",
  icon: "Cross"
},
{
  id: 7,
  title: "Pediatric Dentistry",
  description: "Specialized gentle dental care for children in a comfortable, kid-friendly environment.",
  icon: "Baby"
},
{
  id: 8,
  title: "Periodontics",
  description: "Treatment of gum diseases and maintenance of healthy gums for overall oral health.",
  icon: "HeartPulse"
},
{
  id: 9,
  title: "Dentures & Bridges",
  description: "Custom-fitted dentures and bridges to restore function and aesthetics for missing teeth.",
  icon: "Layers"
}];


export const testimonials = [
{
  id: 1,
  name: "Narendra",
  rating: 5,
  text: "Exceptional experience with outstanding customer service and well-priced treatments. The staff is friendly, making every visit comfortable and stress-free. The clinic is equipped with the latest technology, ensuring top-notch dental care.",
  date: "February 2026"
},
{
  id: 2,
  name: "Diya",
  rating: 5,
  text: "Best experience! Highly recommend Dr. Kotecha's Dental Clinic for quality dental care.",
  date: "June 2024"
},
{
  id: 3,
  name: "Anjali",
  rating: 5,
  text: "Good service. Very professional and caring doctors.",
  date: "May 2024"
},
{
  id: 4,
  name: "Darshana Rathod\xA0",
  rating: 5,
  text: "My 6-year-old daughter was experiencing tooth pain, and the doctor at this clinic provided her with very attentive and skillful treatment. Great with kids!",
  date: "Google Review"
},
{
  id: 5,
  name: "Patient Review",
  rating: 5,
  text: "Very professional and caring doctors. The modern equipment and clean environment make you feel confident. Excellent dental care experience!",
  date: "Google Review"
},
{
  id: 6,
  name: "Patient Review",
  rating: 5,
  text: "Outstanding service! The clinic uses latest technology and the doctors are very experienced. Highly satisfied with the treatment.",
  date: "Google Review"
}];


export const galleryImages = [
{
  id: 11,
  url: "https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/p5gkcdf5_a0ebe0d4-4e31-4ffe-9349-957b891d5c47.jpg",
  title: "Dr. Kotecha with Advanced Equipment",
  category: "equipment"
},
{
  id: 1,
  url: "https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/6lig0oxu_cover%20photo.jpeg",
  title: "Reception Area - Artistry In Every Smile",
  category: "interior"
},
{
  id: 2,
  url: "https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/3fsrnqym_WhatsApp%20Image%202026-04-15%20at%2011.39.30%20AM.jpeg",
  title: "Comfortable Waiting Area",
  category: "interior"
},
{
  id: 3,
  url: "https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/ecqmgpfu_WhatsApp%20Image%202026-04-15%20at%2011.39.33%20AM_2.jpeg",
  title: "Modern Treatment Room",
  category: "equipment"
},
{
  id: 4,
  url: "https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/93q4hs3u_WhatsApp%20Image%202026-04-15%20at%2011.39.34%20AM.jpeg",
  title: "Advanced Dental Equipment",
  category: "equipment"
},
{
  id: 5,
  url: "https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/5mxaxlq4_WhatsApp%20Image%202026-04-15%20at%2011.39.31%20AM.jpeg",
  title: "State-of-the-Art Dental Chair",
  category: "equipment"
},
{
  id: 6,
  url: "https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/75ueulir_WhatsApp%20Image%202026-04-15%20at%2011.39.32%20AM.jpeg",
  title: "Private Consultation Room",
  category: "interior"
},
{
  id: 7,
  url: "https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/6xndjl7b_WhatsApp%20Image%202026-04-15%20at%2011.39.32%20AM_1.jpeg",
  title: "Relaxing Waiting Lounge",
  category: "interior"
},
{
  id: 8,
  url: "https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/yjqm3obf_WhatsApp%20Image%202026-04-15%20at%2011.39.35%20AM.jpeg",
  title: "Welcoming Reception View",
  category: "interior"
},
{
  id: 9,
  url: "https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/utccax43_WhatsApp%20Image%202026-04-15%20at%2011.39.33%20.jpeg",
  title: "Professional Treatment Room",
  category: "equipment"
},
{
  id: 10,
  url: "https://customer-assets.emergentagent.com/job_modern-dental-care-9/artifacts/3hmv9wmd_WhatsApp%20Image%202026-04-15%20at%2011.39.33%20AM.jpeg",
  title: "Modern Waiting Area",
  category: "interior"
}];


export const faqs = [
{
  id: 1,
  question: "What are your consultation charges?",
  answer: "Our initial consultation fee is ₹500, which includes a comprehensive oral examination. This fee is adjusted against treatment costs if you proceed with any procedures."
},
{
  id: 2,
  question: "Do you accept insurance?",
  answer: "Yes, we accept most major dental insurance plans. Please bring your insurance details during your visit, and our staff will help you with the claims process."
},
{
  id: 3,
  question: "Is emergency dental care available?",
  answer: "Yes, we provide emergency dental services. Please call us at 7666222997, and we'll accommodate you as quickly as possible for urgent dental issues."
},
{
  id: 4,
  question: "How long does a dental implant procedure take?",
  answer: "The complete dental implant process typically takes 3-6 months, including healing time. The actual implant placement takes 1-2 hours, but the crown placement happens after osseointegration (3-6 months)."
},
{
  id: 5,
  question: "Do you provide painless treatments?",
  answer: "Absolutely! We use modern anesthesia techniques and advanced equipment to ensure maximum comfort during all procedures. Many patients report minimal to no discomfort."
}];